import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaret = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 8.33333L10 13.3333L5 8.33333L6.16667 7.16666L10 11L13.8333 7.16666L15 8.33333Z",
		fill: "currentColor"
	})
});
export default SvgCaret;
